import { render, staticRenderFns } from "./activitydetails.html?vue&type=template&id=ed4cf838&scoped=true&"
import script from "./activitydetails.js?vue&type=script&lang=js&"
export * from "./activitydetails.js?vue&type=script&lang=js&"
import style0 from "./activitydetails.sass?vue&type=style&index=0&id=ed4cf838&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4cf838",
  null
  
)

component.options.__file = "activitydetails.vue"
export default component.exports